/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Registration_Not_OpenInputs */



/**
* | output |
* | --- |
* | "Registration is not open." |
*
* @param {Tournament_Registration_Not_OpenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_registration_not_open = /** @type {((inputs?: Tournament_Registration_Not_OpenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Registration_Not_OpenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les inscriptions ne sont pas ouvertes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La inscripción no está abierta.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A inscrição não está aberta.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'iscrizione non è aperta.")
	return /** @type {LocalizedString} */ ("Registration is not open.")
});